module.exports = __webpack_public_path__ + "img/home-setting-ware-3.cbdfea09.png";